"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbolToken = exports.ContainerContext = exports.rootContainer = void 0;
const react_1 = require("react");
const inversify_1 = require("inversify");
exports.rootContainer = new inversify_1.Container();
exports.ContainerContext = (0, react_1.createContext)(exports.rootContainer);
function symbolToken(key, global = true) {
    return global ? Symbol.for(key) : Symbol(key);
}
exports.symbolToken = symbolToken;
//# sourceMappingURL=common.js.map